import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  button: {
    backgroundColor: '#F4F4F4 !important',
    borderRadius: 4,
    height: 24,
    minWidth: 24,
    padding: 0,
    width: 24,
  },
}));
